import { useState } from 'react';
import { DateTimeRangePicker } from '@rossum/components/date-time-range-picker';
import { FilterComponentProps } from '../types';
import { FilterComponentWrapper } from './FilterComponentWrapper';

export const FilterDateRange = ({
  filterKey,
  name,
  currentValue,
  confirmFilter,
  onBackClick,
  onClose,
  isRange = false,
  locale,
}: FilterComponentProps<[Date | null, Date | null] | undefined> & {
  isRange?: boolean;
  locale: string;
}) => {
  const [selectedDates, setSelectedDates] = useState<
    [Date | null, Date | null]
  >(currentValue ?? [null, null]);

  const isSubmitDisabled = !selectedDates[0] && !selectedDates[1];

  return (
    <FilterComponentWrapper
      filterKey={filterKey}
      name={name}
      onSubmit={() => {
        confirmFilter(selectedDates);
        onClose();
      }}
      onBackClick={onBackClick}
      onClose={onClose}
      isSubmitDisabled={isSubmitDisabled}
      maxWidth={850}
    >
      <DateTimeRangePicker
        selectedDates={selectedDates}
        setSelectedDates={setSelectedDates}
        operatorValue={isRange ? 'is' : 'after'}
        locale={locale}
      />
    </FilterComponentWrapper>
  );
};
